import React, { useEffect, useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { Create_Api } from '../../API_URL';
import { toast } from 'react-toastify';

const HireDeveloper = () => {

  const [FirstName, setFirstName] = useState('');
  const [LastName, setLastName] = useState('');
  const [Email, setEmail] = useState('');
  const [Number, setNumber] = useState('');
  const [Company, setCompany] = useState('');
  const [Message, setMessage] = useState('');
  const [IsLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");


  const [num1, setNum1] = useState(0);
  const [num2, setNum2] = useState(0);
  const [captchaValue, setCaptchaValue] = useState("");
  const [captchaError, setCaptchaError] = useState("");


  const generateCaptcha = () => {
    const a = Math.floor(Math.random() * 9) + 1;
    const b = Math.floor(Math.random() * 9) + 1;
    setNum1(a);
    setNum2(b);
    setCaptchaValue("");
    setCaptchaError("");
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  const CreateContactUs = async () => {

    if (parseInt(captchaValue) !== num1 + num2) {
      setCaptchaError("Captcha is incorrect");
      return;
    }

    setCaptchaError("");

    let newErrors = {};

    if (!FirstName.trim()) newErrors.FirstName = "FirstName is required";
    if (!LastName.trim()) newErrors.LastName = "LastName is required";
    if (!Email.trim()) newErrors.Email = "Email is required";
    if (!Number.trim()) newErrors.Number = "Number is required";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    const payload = {
      FirstName,
      LastName,
      Email,
      PhoneNumber: Number,
      Company,
      Enquiry: "Let’s Build",
      EnquiryType: "Let’s Build",
      Message
    };

    try {
      setIsLoading(true);
      const response = await Create_Api("api/admin/CreateContactus", payload);
      if (response?.data) {
        // toast.success("Your message has been received. We’ll get back to you as soon as possible.");
        setSuccessMessage(
          "Your message has been received. We’ll get back to you as soon as possible."
        );
        setFirstName("");
        setLastName("");
        setEmail("");
        setNumber("");
        setCompany("");
        setMessage("");
        generateCaptcha();
      } else {
        toast.error(response?.message || "Failed to upload requirement");
      }
    } catch (error) {
      console.error("Error uploading requirement:", error);
      toast.error(error?.response?.message || "Failed to upload requirement");
    } finally {
      setIsLoading(false);
    }
  };


  const inputStyles = "w-full bg-transparent border-0 border-b border-gray-300 py-3 text-[#0F3460] placeholder:text-gray-400 focus:ring-0 focus:border-[#F06115] outline-none transition-colors shadow-none rounded-none";

  return (
    <section className="relative w-full bg-white py-16 lg:py-24 overflow-hidden">
      <img src="/assets/hire-n/wrap1.svg" className='absolute left-0 top-[-427px]' alt="" />
      <div className="max-w-[1440px] w-full mx-auto px-6 lg:px-[80px] relative z-10">
        <div className="flex flex-col lg:flex-row items-center">
          <div className="w-full lg:w-full max-w-[810px] bg-white p-8 lg:p-[40px] z-20 lg:-mr-24 relative">

            <h2 className="text-[#0F3460] text-[20px] lg:text-[30px] font-sora font-[600] mb-10 tracking-tight">
              Let’s Build Something Great Together
            </h2>

            <div className="space-y-8">

              {/* Row 1 */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="group">
                  <input
                    type="text"
                    placeholder="First Name *"
                    className={inputStyles}
                    value={FirstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                  {errors?.FirstName && (
                    <span className="text-red-500 text-sm">{errors?.FirstName}</span>
                  )}
                  <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full h-[1px] bg-gray-300 transition-all duration-300 group-focus-within:h-[1.5px] group-focus-within:bg-[#1E57A5]" />
                </div>
                <div className="group">
                  <input
                    type="text"
                    placeholder="Last Name *"
                    className={inputStyles}
                    value={LastName}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                  {errors?.LastName && (
                    <span className="text-red-500 text-sm">{errors?.LastName}</span>
                  )}
                  <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full h-[1px] bg-gray-300 transition-all duration-300 group-focus-within:h-[1.5px] group-focus-within:bg-[#1E57A5]" />

                </div>
              </div>

              {/* Row 2 */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="group">
                  <input
                    type="email"
                    placeholder="Email Address *"
                    className={inputStyles}
                    value={Email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {errors?.Email && (
                    <span className="text-red-500 text-sm">{errors?.Email}</span>
                  )}

                </div>
                <div className="group">
                  <input
                    type="number"
                    placeholder="Phone Number *"
                    className={inputStyles}
                    value={Number}
                    onChange={(e) => setNumber(e.target.value)}
                  />
                  {errors?.Number && (
                    <span className="text-red-500 text-sm">{errors?.Number}</span>
                  )}
                </div>
              </div>

              {/* Text Area */}
              <div className="group">
                <textarea
                  rows="1"
                  placeholder="Your Message *"
                  className={`${inputStyles} resize-none`}
                  value={Message}
                  onChange={(e) => setMessage(e.target.value)}
                ></textarea>
              </div>

              <div className="grid gap-[6px] col-span-1 lg:col-span-2 mt-[15px]">
                <label className="text-[#242424] text-[16px]">
                  Captcha <span className="text-red-500">*</span>
                </label>

                <div className="flex items-center gap-[15px]">
                  <div className="text-black text-[18px] font-[600]">
                    {num1} + {num2} =
                  </div>

                  <input
                    type="text"
                    value={captchaValue}
                    onChange={(e) => setCaptchaValue(e.target.value)}
                    className="
                                                bg-transparent px-0
                                                border-0 border-b
                                                border-black
                                                text-black
                                                focus:border-black
                                                lg:py-[8px] w-[120px]
                                                outline-none focus:outline-none focus:ring-0
                                            "
                  />

                  <button
                    type="button"
                    onClick={generateCaptcha}
                    className="text-[#ED6800] text-[14px] underline"
                  >
                    Refresh
                  </button>
                </div>

                {captchaError && (
                  <span className="text-red-500 text-sm">{captchaError}</span>
                )}
              </div>

              {/* Submit Button */}
              <div className="pt-4">
                {successMessage && (
                  <div className="mb-4 p-4 bg-green-50 border border-green-300 text-green-700 rounded-md">
                    {successMessage}
                  </div>
                )}
                <button onClick={CreateContactUs} className="flex items-center justify-between px-8 py-3 w-[180px] border border-[#F06115] text-[#F06115] font-semibold hover:bg-[#F06115] hover:text-white transition-all duration-300 group">
                  <span> {IsLoading ? "Please Wait" : "Submit"}</span>
                  <ChevronRight size={20} className="transform group-hover:translate-x-1 transition-transform" />
                </button>
              </div>

            </div>
          </div>

          <div className="w-full lg:w-full max-w-[656px] h-[400px] lg:h-[650px] relative z-10 mt-10 lg:mt-0">
            <img
              src="/assets/hire-n/img1.jpg"
              alt="Meeting"
              className="w-full h-full object-cover"
            />
          </div>

        </div>
      </div>
    </section>
  );
};

export default HireDeveloper;